import React from 'react';
import {
    AUTOMATION_ACTION_ADD_TAG,
    AUTOMATION_ACTION_SEND_EMAIL_APPLICATION,
    AUTOMATION_ACTION_SEND_EMAIL_COLLABORATORS,
    AUTOMATION_ACTION_SET_STEP,
} from './constants';

export const AUTOMATION_ACTION_FORM_COMPONENTS = {
    [AUTOMATION_ACTION_ADD_TAG]: React.lazy(() => import('./AddTagToApplicationActionForm')),
    [AUTOMATION_ACTION_SEND_EMAIL_APPLICATION]: React.lazy(() => import('./SendEmailToApplicationActionForm')),
    [AUTOMATION_ACTION_SEND_EMAIL_COLLABORATORS]: React.lazy(() => import('./SendEmailToCollaboratorsActionForm')),
    [AUTOMATION_ACTION_SET_STEP]: React.lazy(() => import('./SetApplicationStepActionForm')),
};

export function getAutomationActionFormComponent(actionId) {
    return AUTOMATION_ACTION_FORM_COMPONENTS[actionId] || null;
}

export {
    AUTOMATION_ACTION_ADD_TAG,
    AUTOMATION_ACTION_SEND_EMAIL_APPLICATION,
    AUTOMATION_ACTION_SEND_EMAIL_COLLABORATORS,
    AUTOMATION_ACTION_SET_STEP,
} from './constants';
